import {Operation} from "./Operation.js";
import {NUMBER} from "../../../../constants";


export class Count extends Operation {

    static displayName() {
        return "Count";
    }

    static isNumeric() {
        return false;
    }

    static isCategorical() {
        return true;
    }

    static handlesDate() {
        return true;
    }

    static typeOverride() {
        return NUMBER;
    }

    incrementAggregation(newValue) {
        if (this.currValue === null) {
            this.currValue = 0;
        }
        this.currValue += 1;
    }

}

export default Count;